import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const Download = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2561_22)">
        <path
          d="M19.3125 11.1246L11.9864 18L4.6875 11.1502L5.72242 10.1789L11.2238 15.3419V2L12.749 2V15.3419L18.2503 10.1534L19.3125 11.1246Z"
          fill="currentColor"
        />
        <path
          d="M21 20.5V22H3V20.5H21Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2561_22">
          <rect
            width="18"
            height="20"
            fill="white"
            transform="translate(3 2)"
          />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Download

Download.displayName = 'Download'
